import { Link } from "react-router-dom";
import { ProductCard } from "./ProductCard";
import { SectionPoster } from "./SectionPoster";

export function ProductShowcaseSection({ section }) {
  const products = section.products || [];
  const showProducts = section.showProducts !== false && products.length > 0;
  const posterImage = section.posterImage || section.bannerImage;
  const posterLink = section.posterLink || section.bannerCtaLink;

  if (!showProducts && !posterImage && !section.title) return null;

  const titleParts = (section.title || "").split(" ");
  const titleLead = titleParts.slice(0, 2).join(" ");
  const titleAccent = titleParts.slice(2).join(" ");

  return (
    <section className="container mx-auto px-4 lg:px-8 py-8">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6">
        <div>
          {section.subtitle && (
            <p className="text-xs sm:text-sm uppercase tracking-widest text-primary font-semibold mb-2">
              {section.subtitle}
            </p>
          )}
          <h2 className="text-2xl sm:text-3xl font-display font-bold tracking-tight text-foreground">
            {titleAccent ? (
              <>
                {titleLead}{" "}
                <span className="text-gradient-brand">{titleAccent}</span>
              </>
            ) : (
              section.title
            )}
          </h2>
        </div>
        {section.viewAllLink && (
          <Link
            to={section.viewAllLink}
            className="text-sm font-semibold text-primary hover:underline shrink-0"
          >
            {section.viewAllLabel || "View All"}
          </Link>
        )}
      </div>

      {posterImage && (
        <SectionPoster image={posterImage} link={posterLink} alt={section.title} />
      )}

      {showProducts && (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6">
          {products.map((p) => (
            <ProductCard key={p._id || p.id} p={p} variant="legacy" />
          ))}
        </div>
      )}
    </section>
  );
}
